module.exports = __webpack_public_path__ + "media/carousel_images/Imagen5-97a9cb6e.png";